import { makeReact } from '@ifood/react-faster-remote-config';

import { RCSchemas } from './schemas/schemas';

const { Provider, useClient, usePrefetch, useRemoteConfig } = makeReact<RCSchemas>();

export { Provider, useClient, usePrefetch, useRemoteConfig };
